import * as Icons from "lucide-react";
import { Reveal } from "./Reveal";
import { WHY } from "@/data/content";

export default function WhyInvest() {
  return (
    <section id="piyasalar" className="bg-gradient-to-b from-brand-light to-white py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal className="mb-12">
          <h2 className="font-extrabold text-navy tracking-tight text-3xl sm:text-4xl">
            NEDEN BORSAYA YATIRIM YAPILIR?
          </h2>
          <p className="text-brand font-semibold text-lg mt-2">
            Uzun Vadede Servet Oluşturmanın Etkili Yollarından Biri
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {WHY.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.TrendingUp;
            return (
              <Reveal key={w.title} delay={i}>
                <div className="group h-full text-center px-3">
                  <div className="mx-auto grid place-items-center w-20 h-20 rounded-2xl bg-white shadow-[0_10px_30px_rgba(18,58,114,0.10)] ring-1 ring-brand/10 transition-all duration-300 group-hover:-translate-y-1.5 group-hover:shadow-[0_16px_40px_rgba(18,58,114,0.18)]">
                    <Icon className="w-9 h-9 text-brand" strokeWidth={1.6} />
                  </div>
                  <h3 className="font-bold text-navy text-base mt-5 leading-snug">{w.title}</h3>
                  <p className="text-slate-600 text-sm mt-2.5 leading-relaxed">{w.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
